const arabicMessages = {
    invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    userNotFound: "لا يوجد حساب بهذا البريد الإلكتروني",
    emailAlreadyInUse: "هذا البريد الإلكتروني مستخدم بالفعل",
    weakPassword: "كلمة المرور ضعيفة جداً",
    invalidEmail: "صيغة البريد الإلكتروني غير صحيحة",
    userDisabled: "هذا الحساب موقوف",
    notAuthenticated: "يرجى تسجيل الدخول أولاً",
    operationNotAllowed: "هذه العملية غير مسموحة",
    network: "تعذر الاتصال بالإنترنت",
    tooManyRequests: "محاولات كثيرة، حاول لاحقاً",
    permissionDenied: "ليس لديك صلاحية لهذه العملية",
    notFound: "العنصر غير موجود",
    rateLimited: "تم تجاوز الحد المسموح، حاول لاحقاً",
    unknown: "حدث خطأ، يرجى المحاولة مجدداً",
};
export class AppError extends Error {
    code;
    constructor(code, message) {
        super(message ?? arabicMessages[code]);
        this.code = code;
        this.name = "AppError";
    }
    get arabicMessage() {
        return arabicMessages[this.code];
    }
}
//# sourceMappingURL=appError.js.map